import { Component, Inject, Optional } from '@angular/core';
import { MessageTransportService } from '@nx-fe/services';
import { CellRendererBase, CellRendererData, CELL_RENDERER_TOKEN } from '../cell-renderer';
import { MenuCellEvent, MoreActions } from '../renderer.models';

@Component({
  selector: 'more-actions-cell-renderer',
  templateUrl: './more-actions-cell-renderer.component.html',
  styleUrls: ['./more-actions-cell-renderer.component.scss'],
})
export class MoreActionsCellRendererComponent extends CellRendererBase {
  private _data: any;
  readonly DEFAULT_EVENT_ID = 'MoreActionsCellRenderer';

  public moreActions: MoreActions[] = [];

  constructor(
    @Inject(CELL_RENDERER_TOKEN)
    @Optional()
    public params: CellRendererData<object | boolean | string | number>,
    protected eventTransportService: MessageTransportService
  ) {
    super(params, eventTransportService);
  }

  public onActionClick(actionId: string): void {
    const eventParams = this._data.params.eventParams || {};
    const rowContext = Array.isArray(this._data.rowContext) ? this._data.rowContext : [this._data.rowContext];
    const event: MenuCellEvent = {
      rowContext,
      parameters: {
        ...eventParams,
        childEventId: actionId,
      },
    };

    this._eventTransportService.event(this.DEFAULT_EVENT_ID).emit(event);
  }

  public init(cellData: CellRendererData<any>): void {
    this._data = cellData.data;
    this.moreActions = cellData.data.params.actions || [];
  }
}
